document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionEnabled = body.dataset.motionEnabled === 'true' && !reduceMotion;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const header = document.querySelector('[data-site-header]');
  const backToTop = document.querySelector('[data-back-to-top]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-header-search]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');
  let searchCloseTimer;

  const closeMenu = () => {
    if (!menuButton || !menu) return;
    menuButton.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
    body.classList.remove('menu-open');
  };

  const setSearchOpen = (open) => {
    if (!searchToggle || !searchPanel) return;
    window.clearTimeout(searchCloseTimer);
    searchToggle.setAttribute('aria-expanded', String(open));
    searchToggle.classList.toggle('is-active', open);
    if (open) {
      closeMenu();
      searchPanel.hidden = false;
      requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
        if (searchInput) searchInput.focus();
      });
    } else {
      searchPanel.classList.remove('is-open');
      searchCloseTimer = window.setTimeout(() => { searchPanel.hidden = true; }, 230);
      searchToggle.focus();
    }
  };

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      if (!open && searchToggle && searchToggle.getAttribute('aria-expanded') === 'true') setSearchOpen(false);
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      body.classList.toggle('menu-open', !open);
    });
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', () => {
      setSearchOpen(searchToggle.getAttribute('aria-expanded') !== 'true');
    });
    if (searchClose) searchClose.addEventListener('click', () => setSearchOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchToggle.getAttribute('aria-expanded') === 'true') setSearchOpen(false);
    });
    document.addEventListener('pointerdown', (event) => {
      if (searchToggle.getAttribute('aria-expanded') === 'true' && header && !header.contains(event.target)) setSearchOpen(false);
    });
  }

  const onScroll = () => {
    const scrolled = window.scrollY > 24;
    if (header) header.classList.toggle('is-scrolled', scrolled);
    if (backToTop) backToTop.classList.toggle('is-visible', window.scrollY > 650);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (backToTop) {
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }));
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const product = select.closest('[data-product]');
      const prices = product ? product.querySelectorAll('[data-product-price]') : [];
      const buttons = product ? product.querySelectorAll('[data-add-to-cart]') : [];
      if (option.dataset.price) prices.forEach((price) => { price.textContent = option.dataset.price; });
      buttons.forEach((button) => {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Agregar al carrito' : 'Agotado';
      });
    });
  });

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('[data-collection-filters]');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => {
      const open = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!open));
      filters.hidden = open;
      if (!open) filters.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    });
  }

  document.querySelectorAll('[data-recommendations]').forEach(async (element) => {
    if (!element.dataset.url) return;
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const incoming = parsed.querySelector('[data-recommendations]');
      if (incoming && incoming.innerHTML.trim()) {
        element.innerHTML = incoming.innerHTML;
        element.classList.add('is-loaded');
      }
    } catch (error) {
      element.remove();
    }
  });

  const stickyPurchase = document.querySelector('[data-product-sticky]');
  const mainPurchaseButton = document.querySelector('[data-product] form [data-add-to-cart]');
  if (stickyPurchase && mainPurchaseButton) {
    if ('IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver(([entry]) => {
        stickyPurchase.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > entry.boundingClientRect.bottom);
      }, { threshold: 0 });
      purchaseObserver.observe(mainPurchaseButton);
    } else {
      window.addEventListener('scroll', () => stickyPurchase.classList.toggle('is-visible', mainPurchaseButton.getBoundingClientRect().bottom < 0), { passive: true });
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !(form.matches('form.quick-add') || form.matches('[data-product] form.product-form'))) return;
    event.preventDefault();
    const buttons = form.closest('[data-product]') ? form.closest('[data-product]').querySelectorAll('[data-add-to-cart]') : form.querySelectorAll('button');
    const originals = Array.from(buttons, (button) => button.innerHTML);
    buttons.forEach((button) => { button.classList.add('is-loading'); button.textContent = 'Agregando…'; });
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('No se pudo agregar');
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      const count = document.querySelector('[data-cart-count]');
      if (count) {
        count.textContent = cart.item_count;
        count.classList.toggle('cart-count--empty', cart.item_count === 0);
      }
      buttons.forEach((button) => { button.textContent = 'Agregado ✓'; });
      const toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 3400);
      }
      window.setTimeout(() => buttons.forEach((button, index) => { button.innerHTML = originals[index]; button.classList.remove('is-loading'); }), 1600);
    } catch (error) {
      buttons.forEach((button, index) => { button.innerHTML = originals[index]; button.classList.remove('is-loading'); });
      HTMLFormElement.prototype.submit.call(form);
    }
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('[data-quantity-input]');
    const decrease = control.querySelector('[data-quantity-minus]');
    const increase = control.querySelector('[data-quantity-plus]');
    const form = control.closest('[data-cart-form]');
    const updateButton = form ? form.querySelector('[data-cart-update]') : null;
    let updateTimer;

    const queueUpdate = () => {
      if (!form || !updateButton) return;
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => form.requestSubmit(updateButton), 450);
    };
    const setQuantity = (quantity) => {
      if (!input) return;
      input.value = String(Math.max(0, quantity));
      queueUpdate();
    };

    if (decrease) decrease.addEventListener('click', () => setQuantity((Number(input.value) || 0) - 1));
    if (increase) increase.addEventListener('click', () => setQuantity((Number(input.value) || 0) + 1));
    if (input) input.addEventListener('change', queueUpdate);
  });

  document.querySelectorAll('[data-discount-form]').forEach((discountBox) => {
    const input = discountBox.querySelector('[data-discount-code]');
    const apply = discountBox.querySelector('[data-discount-apply]');
    const cartForm = discountBox.closest('[data-cart-form]');
    const applyDiscount = () => {
      const code = input ? input.value.trim() : '';
      if (!code) {
        if (input) input.focus();
        return;
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartUrl = cartForm ? cartForm.dataset.cartUrl : `${root}cart`;
      window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`);
    };
    if (apply) apply.addEventListener('click', applyDiscount);
    if (input) input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount();
      }
    });
  });

  document.querySelectorAll('[data-promo-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-promo-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-promo-dot]'));
    const previous = carousel.querySelector('[data-promo-prev]');
    const next = carousel.querySelector('[data-promo-next]');
    const interval = Math.max(Number(carousel.dataset.interval) || 6000, 4000);
    const autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
    let autoplayTimer;
    let touchStartX = 0;

    const showSlide = (requestedIndex, userInitiated = false) => {
      const nextIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if ('inert' in slide) slide.inert = !active;
      });
      dots.forEach((dot, index) => {
        const active = index === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      activeIndex = nextIndex;
      if (userInitiated) restartAutoplay();
    };

    const stopAutoplay = () => window.clearInterval(autoplayTimer);
    const startAutoplay = () => {
      stopAutoplay();
      if (autoplay && !document.hidden) autoplayTimer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };
    const restartAutoplay = () => startAutoplay();

    if (previous) previous.addEventListener('click', () => showSlide(activeIndex - 1, true));
    if (next) next.addEventListener('click', () => showSlide(activeIndex + 1, true));
    dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.promoDot), true)));
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) startAutoplay(); });
    carousel.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) showSlide(activeIndex + (distance < 0 ? 1 : -1), true);
    }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopAutoplay(); else startAutoplay(); });
    showSlide(activeIndex);
    startAutoplay();
  });

  if (!motionEnabled || !('IntersectionObserver' in window)) {
    body.classList.add('motion-disabled');
    return;
  }

  body.classList.add('motion-ready');
  requestAnimationFrame(() => body.classList.add('page-ready'));

  const revealItems = new Set();
  document.querySelectorAll('#MainContent > .shopify-section').forEach((section, index) => {
    if (index > 0) revealItems.add(section);
  });

  document.querySelectorAll('[data-stagger]').forEach((group) => {
    Array.from(group.children).forEach((child, index) => {
      child.classList.add('reveal-child');
      child.style.setProperty('--reveal-delay', `${Math.min(index * 75, 450)}ms`);
      revealItems.add(child);
    });
  });

  revealItems.forEach((item) => item.classList.add('reveal-item'));
  const observer = new IntersectionObserver((entries, revealObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
  revealItems.forEach((item) => observer.observe(item));

  const interactiveCard = document.querySelector('.hero-task-card, .hero-product');
  const visual = document.querySelector('.hero-premium__visual');
  if (interactiveCard && visual && window.matchMedia('(pointer: fine)').matches) {
    let frame;
    visual.addEventListener('pointermove', (event) => {
      const box = visual.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - 0.5;
      const y = (event.clientY - box.top) / box.height - 0.5;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        interactiveCard.style.setProperty('--tilt-x', `${y * -5}deg`);
        interactiveCard.style.setProperty('--tilt-y', `${x * 7}deg`);
        interactiveCard.style.setProperty('--shift-x', `${x * 8}px`);
        interactiveCard.style.setProperty('--shift-y', `${y * 8}px`);
      });
    });
    visual.addEventListener('pointerleave', () => {
      interactiveCard.style.removeProperty('--tilt-x');
      interactiveCard.style.removeProperty('--tilt-y');
      interactiveCard.style.removeProperty('--shift-x');
      interactiveCard.style.removeProperty('--shift-y');
    });
  }

});
